import { useMemo } from "react";
import { ContentsTitle } from "src/components";
import HistoryDetail from "src/components/histroy/HistoryDetail";
import { useQueryParams } from "src/hooks/useQueryParams";
import BasicInfoDetail from "./basicInfoDetail/BasicInfoDetail";
import GuideProductList from "../product/GuideProductList";
import GuideContractList from "../contract/GuideContractList";
import { useHandleTab } from "../hooks/useTab";
import { GUIDE_DETAIL_TAB } from "../constants/guideTab";

/*
  이용안내 > 상세
 */
const GuideDetail = () => {
  const { queryParams } = useQueryParams();

  // 현재 활성화 되어야하는 tab
  const activeTab = useMemo(() => {
    if (queryParams?.tab) {
      return GUIDE_DETAIL_TAB.find((tab) => tab.value === queryParams?.tab);
    }
    return GUIDE_DETAIL_TAB[0];
  }, [queryParams]);

  const { handleTabClick } = useHandleTab();

  return (
    <div className="">
      <ContentsTitle
        title="이용안내"
        tabs={GUIDE_DETAIL_TAB}
        activeTab={activeTab}
        clickTab={handleTabClick}
        detailInfo={[{ title: "이용안내 ID", value: queryParams.id ? String(queryParams.id) : "" }]}
      />
      {activeTab?.value === "basicInfo" && <BasicInfoDetail />}
      {activeTab?.value === "product" && <GuideProductList />}
      {activeTab?.value === "contract" && <GuideContractList />}
      {/* 변경내역 탭 (AL403, identifier.userGuideId) */}
      {activeTab?.value === "history" && queryParams.id && <HistoryDetail identifier={{ userGuideId: String(queryParams.id) }} />}
    </div>
  );
};
export default GuideDetail;
